import {
  CreateUserGroupOperationRequest,
  CreateUserGroupRequest,
  CreateUserGroupResponse,
} from "@revolutionrobotics/admin-api";
import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { UserGroupApi } from "../../services/configuration";
import { SetError } from "../../services/general";
import { ButtonWithStyle } from "../ButtonWithStyle";
import { FormItem } from "../FormItem";

interface NewUserGroupFormProps {
  setError: Function;
  refresh: Function;
}

export function NewUserGroup({ setError, refresh }: NewUserGroupFormProps) {
  const [validated, setValidated] = useState(false);
  const [inputs, setInputs] = useState<any | null>(null);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);

    if (!inputs || !inputs.name) return;

    const details: CreateUserGroupRequest = {
      details: inputs.details,
      name: inputs.name,
    };
    const req: CreateUserGroupOperationRequest = {
      request: details,
    };

    UserGroupApi.createUserGroup(req).then(
      (response: CreateUserGroupResponse) => {
        console.log(response.id, "has been created.");
        refresh();
      },
      (error) => {
        SetError(error, setError);
      }
    );
  };

  const handleChange = (event: any) => {
    const value = event.target.value;
    const name = event.target.name;
    setInputs((values: any) => ({ ...values, [name]: value }));
  };

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col>
          <Row>
            <FormItem
              title={"Name"}
              type={"text"}
              required={true}
              name={"name"}
              handleChange={handleChange}
            />
          </Row>
          <Row className="mt-2">
            <FormItem
              title={"Details"}
              type={"text"}
              name={"details"}
              handleChange={handleChange}
              isTextArea={true}
            />
          </Row>
        </Col>
      </Row>

      <ButtonWithStyle buttonTitle="Create" type="submit" variant="primary" />
    </Form>
  );
}
